module.exports = __webpack_public_path__ + "img/Weapon_142.b6d21c61.png";